import global$1 from './global.js';
import classof$1 from './classof.js';

var global = global$1;
var classof = classof$1;
var String = global.String;

var toString = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};

export { toString as default };
